import { styled } from '@mui/material/styles';

export const DivStyled = styled('div', {
  name: 'DivStyled',
})(() => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
}));
